import React, { useState } from 'react';
import {
  Anchor,
  Button,
  Checkbox,
  Container,
  Group,
  Paper,
  PasswordInput,
  TextInput,
  Title,
} from '@mantine/core';
import classes from './Login.module.css';
import { AccountService } from '@bobex/react-core/services/AccountService';
import { RouteUtils } from '@bobex/react-core/routes/RouteUtils';
import { useTranslation } from 'react-i18next';
import AuthenticationRequest from '@bobex/react-core/domain/Authentication/AuthenticationRequestDTO';

export default function Login() {
  const { t } = useTranslation();
  const [credentials, setCredentials] = useState(new AuthenticationRequest());

  function submitLogin(event: any) {
    event.preventDefault();
    AccountService.login(credentials).then((response) => {
      AccountService.saveToken(response.accessToken);
      AccountService.saveRefreshToken(response.refreshToken);

      //Set Admin
      AccountService.saveUser(response);

      //Redirect to the right app
      //todo redirect to good page if re-login
      window.location.href = RouteUtils.getBasename() + '/dashboard';
    });
  }

  return (
    <Container size={420} my={40}>
      <Title ta="center" className={classes.title}>
        {t('BackOffice Edition')}
      </Title>
      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <form onSubmit={submitLogin}>
          <TextInput
            label={t('Email or username')}
            placeholder={t('Username')}
            required
            onChange={(value) => {
              setCredentials({
                ...credentials,
                loginId: value.target.value,
              });
            }}
          />
          <PasswordInput
            label={t('Password')}
            placeholder={t('Password')}
            required
            mt="md"
            onChange={(value) => {
              setCredentials({
                ...credentials,
                password: value.target.value,
              });
            }}
          />
          <Group justify="space-between" mt="lg">
            <Checkbox label={t('Remember me')} />
            <Anchor component="button" size="sm">
              {t('Forgot password?')}
            </Anchor>
          </Group>
          <Button fullWidth mt="xl" type="submit">
            {t('Sign in')}
          </Button>
        </form>
      </Paper>
    </Container>
  );
}
